import type React from "react";

import { DevInfoDot } from "#scripts/lib/dev/DevInfoDot.tsx";
import { DevState } from "#scripts/lib/dev/DevState.tsx";
import { useTodoVM } from "../Root.js";
import { LiveValue } from "./LiveValue.tsx";

export const Header: React.FC = () => {
  const vm = useTodoVM();

  return (
    <header data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/Header.tsx:12:13" data-name="header" className="header">
      <h1 data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/Header.tsx:13:11" data-name="h1">Todo List View</h1>
      <DevInfoDot
        data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/Header.tsx:15:9" data-name="DevInfoDot" className="absolute top-2 right-2"
        dismissKey="todo-vm"
        children={<DevState data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/Header.tsx:17:29" data-name="DevState" data={vm} name="Todo VM" />}
        data-hide="#hide"
      />
      <LiveValue query={vm.header.newTodoText$}>
        {(newTodoText) => (
          <input
            data-loc="phosphor-blog/content/_sources/view-model-pattern/todo-vm/components/Header.tsx:23:13" data-name="input" className="new-todo"
            placeholder="What needs to be done?"
            value={newTodoText}
            onChange={(e) => vm.header.updateNewTodoText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                vm.header.addTodo();
              }
            }}
          />
        )}
      </LiveValue>
    </header>
  );
};
